// extracted by mini-css-extract-plugin
export default {"root":"_2pCWzuAYVlRfh3GIFFZqEz","overlay":"_3o1NEvzMV-ddxOtmVaZpAs","description":"_12oaATxCZzrUx_ttla2Wi7","activate":"_2haxhcIWEQCtuvGmHykNfm","deactivate":"D-XP8OIJmLUOhVIqkf1M7"};